"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AccordionWrap = exports.AccordionContent = void 0;
const styled_components_1 = __importDefault(require("styled-components"));
exports.AccordionContent = styled_components_1.default.div `
    details {
        //width: 100% !important;
        max-width: unset !important;
    }

    &.default {
        display: flex;
        flex-wrap: wrap !important;
        flex-direction: column;
        gap: 16px;

        @media screen and (min-width: 768px) {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 16px;
        }

        @media screen and (min-width: 1000px) {
            gap: 24px;
        }

        @media screen and (min-width: 1920px) {
            gap: 32px;
        }
    }

    &.custom-exercise {
        //display: flex;
        //cursor: pointer;
        //flex-direction: column;
        gap: 14px;
        margin-bottom: 12px;
        
    }

    &.exercises {
        display: flex;
        flex-direction: row;
        flex-wrap: wrap !important;
        gap: 16px;

        .checkbox-wrap {
            width: 100%;
        }
    }
`;
exports.AccordionWrap = styled_components_1.default.details `
  display: flex;
  flex-direction: column;
  background-color: white;
    flex-wrap: wrap !important;
  font-family: Inter, sans-serif;
  box-sizing: border-box;

  &:not(:has(.non-empty)) {
    display: none;
  }

  summary {
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;

    svg {
      transition: all 200ms ease;
    }
  }

  &[open] > summary svg {
    transform: rotate(180deg);
  }

  &.framed {
    //flex-grow: 1;
    align-items: center;
    justify-content: center;
    padding: 32px 16px;
    min-width: 67px;
    outline: 1px solid #cbcbcb;
    border-radius: 4px;
    list-style: none;
    max-width: 315px;
    height: fit-content;

    summary {
      font-family: Inter, sans-serif;
      font-size: 16px;
      font-weight: 400;
      line-height: 24px;
      justify-content: flex-start;
    }

    &[open] {
      width: 100%;
      max-width: unset;

      grid-column: span 2 / span 2;

      &.exercises {
        grid-column: auto;
      }
    }

    &[open] > summary {
      color: #7b4ef8;
      margin-bottom: 16px;
    }

    summary::-webkit-details-marker,
    summary::marker {
      content: "";
    }

    @media screen and (min-width: 768px) {
      padding: 32px;
      min-width: 94px;

      &[open] {
        padding: 32px;
      }

      &[open] > summary {
        margin-bottom: 32px;
      }
    }

    @media screen and (min-width: 1000px) {
      min-width: 114px;
    }

    @media screen and (min-width: 1920px) {
      padding: 35px 35px 32px 35px;
      min-width: 137px;

      &[open] {
        padding: 35px 32px;
      }
    }
  }

  &.default {
    width: 100%;

    summary {
      gap: 8px;
      font-size: 20px;
      line-height: 24px;
      font-weight: 500;
      justify-content: flex-start;
      color: #7b4ef8;

      @media screen and (max-width: 767px) {
        span {
          width: min-content;
        }
      }
    }
  }
`;
